import { Component, OnInit } from '@angular/core';
import { SeoService } from 'src/app/services/seo.service';

@Component({
  selector: 'v2m-blog-video-format',
  templateUrl: './blog-video-format.component.html',
  styleUrls: ['./blog-video-format.component.scss']
})
export class BlogVideoFormatComponent implements OnInit {
  constructor(private seo: SeoService) {}

  ngOnInit() {
    this.seo.updateTitle('video2manual - Ausgabeformate');
    this.seo.updateKeywords('FAQ,Videoformate,Ausgabeformate,Publizieren');
  }
}
